
!function() { if (!window.klaviyo) { window._klOnsite = window._klOnsite || []; try { window.klaviyo = new Proxy({}, { get: function(n, i) { return "push" === i ? function() { var n; (n = window._klOnsite).push.apply(n, arguments) } : function() { for (var n = arguments.length, o = new Array(n), w = 0; w < n; w++)o[w] = arguments[w]; var t = "function" == typeof o[o.length - 1] ? o.pop() : void 0, e = new Promise((function(n) { window._klOnsite.push([i].concat(o, [function(i) { t && t(i), n(i) }])) })); return e } } }) } catch (n) { window.klaviyo = window.klaviyo || [], window.klaviyo.push = function() { var n; (n = window._klOnsite).push.apply(n, arguments) } } } }();

const apiKey = window.settings.klaviyoPublicKey;

function subscribe(listId, email, params = {}) {
  const config = Object.assign({}, params, {
    g: listId,
    email
  })

  const body = Object.keys(config).reduce((str, key) => {
    str.append(key, config[key])
    return str
  }, new URLSearchParams())

  return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
    method: 'POST',
    headers: {
      "Access-Control-Allow-Headers": "*",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
    },
    body
  }).then(res => res.json())
}


// New fetch for Klaviyo

const fetches = [];

payloadSubscribe = ({ email, name, listID, scLink }) => ({
  data: {
    type: "subscription",
    attributes: {
      profile: {
        data: {
          type: "profile",
          attributes: {
            email: email,
            first_name: name,
            subscriptions: {
              email: {
                marketing: {
                  consent: "SUBSCRIBED"
                }
              }
            }
          },
          properties: {
            tags: ['Share cart form'],
            cartLink: scLink.value || ''
          }
        }
      }
    },
    relationships: {
      list: {
        data: {
          type: "list",
          id: listID
        }
      }
    }
  }
});

// end new fetch for Klaviyo





function variantUpdated(currentVariant, currentDrawer, jsonData) {
  const itemKey = currentDrawer.dataset.drawer.replace(`option-${ currentDrawer.dataset.drawer.split('-')[1] }-`, '');
  var parentDrawer = document.querySelector(`[data-drawer="option-item-${ itemKey }"]`)
  var values = document.querySelectorAll(`[data-drawer*="-${ itemKey }"] .gr-value`);

  values.forEach(function(item) {
    var itemPriceElm = item.querySelector('[data-price]');
    var itemStatusElm = item.querySelector('[data-status]');

    var itemValue = item.dataset.value;
    var itemOption = item.dataset.option;

    if (itemValue === currentVariant[`option${ +itemOption + 1 }`]) {
      item.classList.add('active');
      var optionInput = parentDrawer.querySelector(`input[data-option-position][value="${ itemValue }"]`)

      if (optionInput) {
        var scrollable = optionInput.closest('.HorizontalList');
        scrollable.scroll(optionInput.parentElement.offsetLeft - (scrollable.offsetWidth / 2) + (optionInput.parentElement.offsetWidth / 2), 0)
      }
    } else {
      item.classList.remove('active');
    }

    var tmpVariant = {
      option1: currentVariant.option1,
      option2: currentVariant.option2,
      option3: currentVariant.option3
    }

    tmpVariant[`option${ +itemOption + 1 }`] = itemValue;
    var itemVariant = jsonData.find(i => i.option1 === tmpVariant.option1 && i.option2 === tmpVariant.option2 && i.option3 === tmpVariant.option3);
    if (itemVariant) {
      itemPriceElm.textContent = `${ (itemVariant.price - currentVariant.price) >= 0 ? '+' : '-' } ${ slate.Currency.formatMoney(Math.abs(currentVariant.price - itemVariant.price), window.theme.moneyFormat) }`;
      itemStatusElm.textContent = itemVariant.available ? languages.variantAvailable : languages.variantUnavailable;

      if (!itemVariant.available) {
        itemStatusElm.classList.add('unavailable');
        item.classList.add('disabled');
      } else {
        itemStatusElm.classList.remove('unavailable');
        item.classList.remove('disabled');
      }
    } else {
      itemStatusElm.textContent = languages.variantNotFound;
      item.classList.add('disabled', 'click-none');
      itemStatusElm.classList.add('unavailable');
    }
  })
}

window.addEventListener('load', function() {
  var pageOverlay = document.querySelector('.PageOverlay');

  function openDrawer(toggle) {
    //document.querySelectorAll(`.gr-drawer`).forEach(i => i.classList.remove('open'))
    var drawer = document.querySelector(`.gr-drawer[data-drawer="${ toggle }"]`);
    if (drawer) {
      drawer.classList.add('open');
      pageOverlay.classList.add('is-visible');
    }
  }

  function closeDrawer(drawer) {
    document.querySelectorAll(`.gr-drawer`).forEach(i => i.classList.remove('open'))
    pageOverlay.classList.remove('is-visible');
  }

  function renderCart() {
    fetch(window.routes.cartUrl + '?view=ajax&timestamp=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function(content) {
      content.text().then(function(html) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = html;

        var cartNodeParent = document.querySelector('.Cart').parentNode;
        cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), document.querySelector('.gr-cart__right').parentNode);

        document.dispatchEvent(new Event('cart:page:rendered'));
      });
    });
  }

  function cartAdd(id, quantity, callback) {
    fetch(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify({ id: id, quantity: quantity }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function(cart) {
      cart.json().then(function(content) {
        if (callback) {
          callback()
        }
      });
    });
  }

  function cartChange(id, quantity, replaceHTML = false) {
    fetch(window.routes.cartChangeUrl + '.js', {
      body: JSON.stringify({ id: id, quantity: quantity }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function(cart) {
      cart.json().then(function(content) {
        if (replaceHTML) {
          renderCart()
          if (window.KlarnaOnsiteService) window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
          pageOverlay.classList.remove('is-visible');
        }
      });
    });
  }

  document.addEventListener('cart:page:rendered', function() {
    var drawers = document.querySelectorAll('.gr-drawer[data-drawer^="option-"]');
    var drawerToggles = document.querySelectorAll('[data-drawer-toggle]');
    drawerToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        openDrawer(toggle.dataset.drawerToggle)
      })
    })

    drawers.forEach(function(drawer) {
      var drawerClose = drawer.querySelector('.gr-drawer__close');
      var drawerBack = drawer.querySelector('.gr-drawer__back');
      const itemKey = drawer.dataset.drawer.replace(`option-${ drawer.dataset.drawer.split('-')[1] }-`, '');
      var productData = JSON.parse(document.querySelector(`script[data-product="${ itemKey }"]`).innerHTML);
      var parentDrawer = document.querySelector(`[data-drawer="option-item-${ itemKey }"]`)
      var initialCheckedValues = Array.from(drawer.querySelectorAll('input:checked')).map(i => i.value)

      window.shouldUpdate = false;
      var initialVariant = productData.find((variant) => {
        if (initialCheckedValues.length === 1) {
          return variant.option1 === initialCheckedValues[0]
        } else if (initialCheckedValues.length === 2) {
          return variant.option1 === initialCheckedValues[0] && variant.option2 === initialCheckedValues[1]
        } else {
          return variant.option1 === initialCheckedValues[0] && variant.option2 === initialCheckedValues[1] && variant.option3 === initialCheckedValues[2]
        }
      })

      if (window.KlarnaOnsiteService) window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })

      drawerClose.addEventListener('click', function() {
        closeDrawer(drawer)
      });

      if (drawerBack) {
        drawerBack.addEventListener('click', function() {
          drawer.classList.remove('open')
        });
      }

      if (!drawer.dataset.drawer.includes('option-item-')) {
        var values = drawer.querySelectorAll('.gr-value');

        values.forEach(function(item) {
          var value = item.dataset.value;
          var option = item.dataset.option;

          item.addEventListener('click', function() {
            item.parentElement.childNodes.forEach(i => i.classList.remove('active'));
            item.classList.add('active');

            var optionInput = parentDrawer.querySelector(`input[name="${ itemKey }-option-${ option }"][value="${ value }"]`);
            if (optionInput) {
              optionInput.click();
            }

            var checkedValues = Array.from(parentDrawer.querySelectorAll('input:checked')).map(i => i.value)

            var matchingVariant = productData.find((variant) => {
              if (checkedValues.length === 1) {
                return variant.option1 === checkedValues[0]
              } else if (checkedValues.length === 2) {
                return variant.option1 === checkedValues[0] && variant.option2 === checkedValues[1]
              } else {
                return variant.option1 === checkedValues[0] && variant.option2 === checkedValues[1] && variant.option3 === checkedValues[2]
              }
            })

            if (matchingVariant) {
              variantUpdated(matchingVariant, drawer, productData)
              drawer.classList.remove('open')
            }
          })

          if (item.classList.contains('active')) {
            item.click()
          }
        })

      } else {
        var saveBtn = drawer.querySelector('[data-save]')

        saveBtn.addEventListener('click', function() {
          var checkedValues = Array.from(drawer.querySelectorAll('input:checked')).map(i => i.value)

          var matchingVariant = productData.find((variant) => {
            if (checkedValues.length === 1) {
              return variant.option1 === checkedValues[0]
            } else if (checkedValues.length === 2) {
              return variant.option1 === checkedValues[0] && variant.option2 === checkedValues[1]
            } else {
              return variant.option1 === checkedValues[0] && variant.option2 === checkedValues[1] && variant.option3 === checkedValues[2]
            }
          })
          if (matchingVariant) {
            if (matchingVariant.id !== initialVariant.id) cartAdd(matchingVariant.id, 1, function() {
              cartChange(drawer.dataset.drawer.split('-')[2].split(':')[0], 0, true)
            });

            var openDrawer = document.querySelector('.gr-drawer.open');
            if (openDrawer) {
              closeDrawer(openDrawer);
            }

            if (window.shouldUpdate) {
              renderCart();
              if (window.KlarnaOnsiteService) window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
              window.shouldUpdate = false;
            }
          }
        })

        var optionInputs = drawer.querySelectorAll('input');

        optionInputs.forEach(input => {
          input.addEventListener('click', function() {
            var optionValue = document.querySelector(`[data-drawer*="${ drawer.dataset.drawer.split('-')[2] }"] .gr-value[data-value="${ input.value }"]`);
            if (optionValue) {
              optionValue.click();
            }
          })
        })
      }
    })

    const cartTable = document.querySelector('.gr-cart__table');
    const itemDrawers = cartTable.querySelectorAll('.gr-drawer[data-drawer^="option-item-"]')

    itemDrawers.forEach(drawer => {
      const qtyBtns = drawer.querySelectorAll('.QuantitySelector__Button');

      qtyBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var input = btn.parentElement.querySelector('input');
          var sameInput = cartTable.querySelector(`[id="${ input.dataset.id }"]`)
          input.value = btn.dataset.quantity
          if (sameInput) sameInput.value = btn.dataset.quantity

          cartChange(btn.dataset.lineId, btn.dataset.quantity, +btn.dataset.quantity === 0);
          window.shouldUpdate = true;

          if (btn.classList.contains('plus')) {
            btn.parentElement.querySelector('.minus').dataset.quantity = +btn.dataset.quantity - 1
            btn.dataset.quantity = +btn.dataset.quantity + 1
          } else {
            btn.parentElement.querySelector('.plus').dataset.quantity = +btn.dataset.quantity + 1
            btn.dataset.quantity = +btn.dataset.quantity - 1
          }
        })
      })
    })

    const agreementLink = document.querySelector('.agreement__input-wrap a');
    if (agreementLink) {
      agreementLink.addEventListener('click', function() {
        agreementBox.classList.add('open');
        pageOverlay.classList.add('is-visible');

        agreementPageBox.classList.add('active');
        agreementBox.style.maxWidth = agreementPageBox.classList.contains('active') ? '700px' : null;
      })
    }

    const shareCart = document.querySelector('[data-drawer="share-cart"]');
    if (shareCart) {
      var shareCartDrawerClose = shareCart.querySelector('.gr-drawer__close');
      var shareCartDrawerContinue = shareCart.querySelector('.button-continue');

      var shareCartForm = shareCart.querySelector('[data-list]');
      var scSubmit = document.getElementById('scSubmit');
      var scName = document.getElementById('scName');
      var scEmail = document.getElementById('scEmail');
      var scLink = document.getElementById('cartCopyLink');
      var scError = document.getElementById('scError');
      var scTerms = document.getElementById('scTerms');
      var scSuccessContent = document.querySelector('.sc-success__content');

      if (scSubmit) {
        shareCartDrawerClose.addEventListener('click', function() {
          closeDrawer(shareCart)
        });

        shareCartDrawerContinue.addEventListener('click', function() {
          closeDrawer(shareCart)
        });

        scSubmit.addEventListener('click', async () => {
          if (scTerms.checked && scName.value.length > 0 && scEmail.value.length > 0) {
            scSuccessContent.textContent = scSuccessContent.textContent.replace('EMAIL', scEmail.value);


            function onIdentifyCompleteCallback() {
              klaviyo.track("Custom Event");
            }

            const subscribeFetch = fetch(
              `https://a.klaviyo.com/client/subscriptions?company_id=${ apiKey }`,
              {
                method: 'POST',
                headers: {
                  accept: 'application/vnd.api+json',
                  revision: '2025-04-15',
                  'content-type': 'application/vnd.api+json'
                },
                body: JSON.stringify(payloadSubscribe({ email: scEmail.value, name: scName.value, listID: shareCartForm.dataset.list, scLink: scLink.value })),
              }
            );
            fetches.push(subscribeFetch);

            try {
              const responses = await Promise.all(fetches);

              // Check if any response is not ok
              const hasError = responses.some(res => !res.ok);

              if (hasError) {
                // Collect all error messages
                const errors = await Promise.all(
                  responses.map(async res => {
                    if (!res.ok) {
                      const json = await res.json();
                      return json.errors ? json.errors.map(e => e.detail).join(', ') : res.statusText;
                    }
                    return null;
                  })
                );
                throw new Error(errors.filter(Boolean).join('; '));
              }


              // Check if Klaviyo is properly loaded
              if (typeof window.klaviyo !== 'undefined' && window.klaviyo.push) {
                const trackingData = {
                  cartLink: scLink.value || '',
                  $value: 0, // You could calculate cart value here
                  $extra: {
                    cartItems: scLink.value || '',
                    sharedBy: scName.value || ''
                  }
                };

                function onIdentifyCompleteCallback() {
                  klaviyo.track("Cart Shared", trackingData);
                }
                const identityProperties = {
                  'email': scEmail.value,
                };

                klaviyo.identify(identityProperties, onIdentifyCompleteCallback);
                
                shareCart.classList.add('success');
                cartSharedTracked = true;

              } else {
                console.error('Klaviyo: klaviyo object not found or push method not available');
              }

            } catch (error) {
              console.error('Error:', error);
            }

            // subscribe(shareCartForm.dataset.list, scEmail.value, {
            //   $first_name: scName.value,
            //   $fields: ["Tags", "Cart link"],
            //   "Tags": 'Share cart form',
            //   "Cart link": scLink.value || ''
            // }).then((response) => {
            //   if (response.success) {

            //     // Check if Klaviyo is properly loaded
            //     if (typeof window.klaviyo !== 'undefined' && window.klaviyo.push) {
            //       const trackingData = {
            //         email: scEmail.value,
            //         cartLink: scLink.value || '',
            //         $value: 0, // You could calculate cart value here
            //         $extra: {
            //           cartItems: scLink.value || '',
            //           sharedBy: scName.value || ''
            //         }
            //       };

            //       klaviyo.push(['track', 'Cart Shared', trackingData]);

            //       cartSharedTracked = true;
            //     } else {
            //       console.error('Klaviyo: klaviyo object not found or push method not available');
            //     }

            //     subscribe(shareCartForm.dataset.cartlist, scEmail.value, {
            //       $first_name: scName.value,
            //       $fields: ["Tags", "Cart link"],
            //       "Tags": 'Share cart form',
            //       "Cart link": scLink.value || ''
            //     }).then(response => {
            //       if (response.success) {
            //         shareCart.classList.add('success');

            //         if (!cartSharedTracked) {

            //           // Check if Klaviyo is properly loaded
            //           if (typeof window.klaviyo !== 'undefined' && window.klaviyo.push) {
            //             const trackingData = {
            //               email: scEmail.value,
            //               cartLink: scLink.value || '',
            //               $value: 0, // You could calculate cart value here
            //               $extra: {
            //                 cartItems: scLink.value || '',
            //                 sharedBy: scName.value || ''
            //               }
            //             };

            //             klaviyo.push(['track', 'Cart Shared', trackingData]);
            //           } else {
            //             console.error('Klaviyo: klaviyo object not found or push method not available');
            //           }
            //         }
            //       } else {
            //         scError.textContent = response.errors;
            //         console.error(response.errors)
            //       }
            //     })
            //   } else {
            //     scError.textContent = response.errors;
            //     console.error(response.errors)
            //   }
            // });
          } else if (scName.value.length > 0 && scEmail.value.length > 0 && !scTerms.checked) {
            scError.textContent = scError.dataset.term
            setTimeout(() => {
              scError.textContent = ''
            }, 3000)
          } else {
            scError.textContent = scError.dataset.field
            setTimeout(() => {
              scError.textContent = ''
            }, 3000)
          }
        })
      }
    }
  })

  /**
   * TOS
   */

  const agreementBox = document.querySelector('#agreementBox');
  const agreementBoxClose = agreementBox.querySelector('.gr-drawer__close');
  const agreementBtns = agreementBox.querySelectorAll('.btn');
  const agreementPageBox = agreementBox.querySelector('.agreementBox__page');
  const agreementLink = agreementBox.querySelector('a[data-href]');

  if (agreementLink) {
    agreementLink.addEventListener('click', function() {
      agreementPageBox.classList.toggle('active');

      agreementBox.style.maxWidth = agreementPageBox.classList.contains('active') ? '700px' : null
    })
  }



  agreementBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      agreementBox.classList.remove('open');
      pageOverlay.classList.remove('is-visible')
    })
  })

  agreementBoxClose.addEventListener('click', () => {
    agreementBox.classList.remove('open');
    pageOverlay.classList.remove('is-visible')
  })


  pageOverlay.addEventListener('click', function() {
    var openDrawer = document.querySelector('.gr-drawer.open');
    if (openDrawer) {
      closeDrawer(openDrawer);
    }

    var openTOS = document.querySelector('#agreementBox.open');
    if (openTOS) {
      agreementBox.classList.remove('open')
      pageOverlay.classList.remove('is-visible')
    }
  })
})
